// extracted by mini-css-extract-plugin
export var borderRadius = "_cr-4";
export var large = "_cr-3";
export var logoContainer = "_cr-0";
export var nameLogo = "_cr-2";
export var small = "_cr-1";